import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/views/Page'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'a-new-wearable',
      component: Page
    },
    {
      path: '/a-new-wearable',
      redirect: '/'
    },
    {
      path: '/experience',
      name: 'experience',
      component: Page
    },
    {
      path: '/payments',
      name: 'payments',
      component: Page
    },
    {
      path: '/fitness',
      name: 'fitness',
      component: Page
    },
    {
      path: '/tech-features',
      name: 'tech-features',
      component: Page
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: Page
    },
    {
      path: '/work-with-us',
      name: 'work-with-us',
      component: Page
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: Page
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js